export const DEFAULT_LANGUAGE = 'en';

export const FALLBACK_LANGUAGES = [
  { code: 'en', label: 'English' },
  { code: 'it', label: 'Italian' },
];

export const translations = {
  en: {
    'language.label': 'Language',
    'nav.toggle': 'Toggle navigation',
    'nav.about': 'About',
    'nav.experience': 'Experience',
    'nav.projects': 'Projects',
    'nav.contact': 'Contact',
    'common.close': 'Close',
    'errors.about': 'Failed to load About.',
    'errors.experience': 'Failed to load Experience.',
    'errors.projects': 'Failed to load Projects.',
    'errors.project': 'Failed to load project.',
    'about.subtitle': 'ABOUT ME',
    'about.avatarAlt': "{name}'s avatar",
    'about.skills': 'Key Skills',
    'about.achievements': 'Achievements',
    'about.cta': "Do you have a project in mind? Let's talk!",
    'experience.title': 'Experience',
    'experience.present': 'Present',
    'projects.titlePrefix': 'My',
    'projects.titleHighlight': 'Projects',
    'projects.subtitle': "Here are some of the projects I've worked on. Each project showcases my skills in creating modern, responsive, and user-friendly web applications.",
    'projects.viewProject': 'View Project',
    'projectDetail.screenshots': 'Project Screenshots',
    'projectDetail.back': 'Back to Projects',
    'projectDetail.screenshotAlt': '{name} screenshot {number}',
    'projectDetail.enlargedAlt': 'Enlarged screenshot',
    'contact.connectTitle': "Let's Connect",
    'contact.intro': "Have a project in mind or just want to say hi? Fill out the form and I'll get back to you as soon as possible.",
    'contact.github': 'Visit my GitHub profile',
    'contact.linkedin': 'Connect with me on LinkedIn',
    'contact.formTitle': 'Contact Me',
    'contact.formAria': 'Contact form',
    'contact.success': "Thanks! I'll be in touch.",
    'contact.name': 'Name',
    'contact.email': 'Email',
    'contact.message': 'Message',
    'contact.send': 'Send Message',
    'contact.sending': 'Sending...',
    'footer.rights': 'Portfolio Website. All rights reserved.',
  },
  it: {
    'language.label': 'Lingua',
    'nav.toggle': 'Apri menu di navigazione',
    'nav.about': 'Chi sono',
    'nav.experience': 'Esperienza',
    'nav.projects': 'Progetti',
    'nav.contact': 'Contatti',
    'common.close': 'Chiudi',
    'errors.about': 'Impossibile caricare la sezione Chi sono.',
    'errors.experience': "Impossibile caricare l'esperienza.",
    'errors.projects': 'Impossibile caricare i progetti.',
    'errors.project': 'Impossibile caricare il progetto.',
    'about.subtitle': 'CHI SONO',
    'about.avatarAlt': 'Avatar di {name}',
    'about.skills': 'Competenze',
    'about.achievements': 'Risultati',
    'about.cta': 'Hai un progetto in mente? Parliamone!',
    'experience.title': 'Esperienza',
    'experience.present': 'Presente',
    'projects.titlePrefix': 'I miei',
    'projects.titleHighlight': 'Progetti',
    'projects.subtitle': 'Ecco alcuni dei progetti a cui ho lavorato. Ogni progetto mostra le mie competenze nella creazione di applicazioni web moderne, responsive e facili da usare.',
    'projects.viewProject': 'Vedi progetto',
    'projectDetail.screenshots': 'Screenshot del progetto',
    'projectDetail.back': 'Torna ai progetti',
    'projectDetail.screenshotAlt': '{name} screenshot {number}',
    'projectDetail.enlargedAlt': 'Screenshot ingrandito',
    'contact.connectTitle': 'Restiamo in contatto',
    'contact.intro': 'Hai un progetto in mente o vuoi solo salutarmi? Compila il modulo e ti risponderò il prima possibile.',
    'contact.github': 'Visita il mio profilo GitHub',
    'contact.linkedin': 'Collegati con me su LinkedIn',
    'contact.formTitle': 'Contattami',
    'contact.formAria': 'Modulo di contatto',
    'contact.success': 'Grazie! Ti risponderò presto.',
    'contact.name': 'Nome',
    'contact.email': 'Email',
    'contact.message': 'Messaggio',
    'contact.send': 'Invia messaggio',
    'contact.sending': 'Invio...',
    'footer.rights': 'Sito portfolio. Tutti i diritti riservati.',
  },
};

export function interpolate(message, values = {}) {
  return Object.entries(values).reduce(
    (text, [key, value]) => text.replace(new RegExp(`\\{${key}\\}`, 'g'), value),
    message
  );
}
